export default "__VITE_ASSET__C8hm5DPd__"